import { z } from "zod";
export const healthStatusEnum = z.enum(["OK", "WARN", "DOWN"]);
export const channelHealthSchema = z.object({
    idcompany: z.number(),
    companyName: z.string().nullable(),
    idcanal: z.number(),
    providerCode: z.string(),
    status: healthStatusEnum,
    lastInboundAt: z.string().nullable(),
    lastOutboundAt: z.string().nullable(),
    msgIn60Min: z.number(),
    msgOut60Min: z.number(),
    latencyP95Ms: z.number().nullable(),
    checkedAt: z.string(),
});
//# sourceMappingURL=healthcheck.js.map